import React from 'react';
import { toAbsoluteUrl, encryptId } from '../../../../_metronic/helpers';
import { colorStatusTask } from '../../../../_metronic/helpers/CustomElements';
import { randomClass } from '../../../../_metronic/helpers/CustomElements';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { RiskModel } from '../../risks/models/RiskModel';

type Props = {
  tasks: RiskModel[];
  loadingListTaks: boolean;
};

const CardRisks: React.FC<Props> = ({ tasks, loadingListTaks }) => {
  const columns: any = [
    {
      id: 'id',
      name: <div className="fw-bolder text-muted me-5"></div>,
      selector: (row: any) => row.id,
      cell: (row: any) => (
        <div className="timeline-badge">
          <i
            className={`fa fa-genderless text-primary fs-1 ${randomClass()}`}
          ></i>
        </div>
      ),
      width: '80px',
      sortable: false,
    },
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Nombre</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => (
        <>
          <Link
            to={`/oportunidades_riesgos/${encryptId(row.oportunidad.id.toString())}/edit/${encryptId(row.id.toString())}`}
          >
            {row.nombre}
          </Link>
        </>
      ),
      sortable: true,
    },
    {
      id: 'status',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.statusRiesgo.name,
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <div className="d-flex justify-content-start flex-column fs-012">
            <div className={`d-flex  ${colorStatusTask(row.statusRiesgo.code)}`}>
              {row.statusRiesgo.name}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      id: 'prioridad',
      name: <div className="fw-bolder text-muted me-5">Prioridad</div>,
      selector: (row: any) =>
        row.prioridadRiesgo ? row.prioridadRiesgo.name : 'Sin prioridad',
      sortable: true,
      cell: (row: any) => (
        <>
          <div className="text-gray-700">
            {row.prioridadRiesgo ? row.prioridadRiesgo.name : 'Sin prioridad'}
          </div>
        </>
      ),
    },
    {
      id: 'etapa',
      name: <div className="fw-bolder text-muted me-5">Etapa</div>,
      selector: (row: any) => row.etapaRiesgo.name,
      cell: (row: any) => (
        <>
          <div className="text-gray-700">
            {row.etapaRiesgo ? row.etapaRiesgo.name : 'Sin Etapa'}
          </div>
        </>
      ),
      sortable: true,
    },
  ];

  return (
    <>
      <div className="card card-flush h-md-100">
        <div className={`card-body d-flex flex-column`}>
          <>
            <div className="fs-1 fw-bold text-gray-800">
              <span className="me-2">
                <span className="fs-015">{'Riesgos'}</span>
              </span>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {!loadingListTaks ? (
                <DataTable
                  columns={columns}
                  data={tasks}
                  expandableRowsHideExpander
                  responsive
                  customStyles={{
                    rows: {
                      style: {
                        borderBottom: '1px dashed #e4e6ef !important',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                      },
                    },
                    headRow: {
                      style: {
                        borderBottom: '1px dashed  #e4e6ef',
                      },
                    },
                    pagination: {
                      style: {
                        borderTopStyle: 'none',
                      },
                    },
                  }}
                  paginationComponentOptions={{
                    rowsPerPageText: 'Registros por página',
                    rangeSeparatorText: 'de',
                  }}
                  noDataComponent={
                    <>
                      <div className="d-flex align-items-center mt-20">
                        <div className="mt-20">
                          <h3 className="font-weight-mormal fs-5 timeline-content text-muted ">
                            No existen registros de riesgos
                          </h3>
                          <div className="d-flex align-items-center">
                            <img
                              className="mx-auto  h-200px"
                              src={toAbsoluteUrl(
                                '/media/illustrations/sketchy-1/bg-task-empty.png'
                              )}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  }
                ></DataTable>
              ) : (
                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                  <div className="text-center">
                    <h1 className="fw-semibold text-gray-800 text-center lh-lg">
                      <span
                        className="indicator-progress text-primary"
                        style={{ display: 'block' }}
                      >
                        <div className="text-center mt-3">
                          <span className="spinner-border spinner-border-lg align-middle ms-2"></span>
                        </div>
                      </span>
                    </h1>
                  </div>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export { CardRisks };
